import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@p1s/p1s-common-react/Button";
import { resendUserSetPasswordEmail } from "../../actions/UserActions";
import ServerError from "../common/ServerError";
import { loginSteps } from "../../utilities/Constants";
import { isEnterPressed } from "newApp/utilities/EventsHelper";
import SoleSourceTitle from "newApp/controls/SoleSourceTitle";

export class VerifyEmailForm extends Component {
    constructor (props) {
        super(props);

        this.state = {
            validationError: undefined
        };

        this.onResendClick = this.onResendClick.bind(this);
        this.onEnter = this.onEnter.bind(this);
    }

    onResendClick () {
        this.props.resendUserSetPassword(this.props.email);
    }

    onEnter (e) {
        isEnterPressed(e) ? this.onNext() : {};
    }

    isSlideActive () {
        return this.props.step === loginSteps.verifyEmailForm;
    }

    render () {
        const serverError = this.props.serverError;
        const validationError = this.state.validationError;

        const hasServerError = serverError && serverError != null && serverError.length > 0;
        const hasValidationError = validationError != null && validationError.length > 0;

        if (this.props.step !== loginSteps.verifyEmailForm)
            return null;

        const text = this.props.authenticationTypeChanged
            ? "Your organization's authentication method has changed. To continue, we need to verify that this is your email address."
            : "To continue, we just need to verify that this is your email address.";

        return (
            <div>
                <div className="verifyEmail-popup" name="verifyEmail">
                    <SoleSourceTitle />
                    <div className="signIn-form-title">Verify Your Email Address</div>
                    <br/>
                    <div className="signIn-form-subtitle">
                        <span name="email-field" className="email email-link">
                            <span>{this.props.email}</span>
                        </span>
                    </div>

                    <div name="body-field" className="signIn-form-subtitle">
                        {text}
                    </div>

                    <div className="button-container">
                        <Button id="btnSendVerificationEmail" className="btn btn-primary-action pull-right"
                            onClick={this.onResendClick}>Send Verification Email</Button>
                    </div>

                    <ServerError
                        errorSummary={"Login Failed"}
                        serverError={serverError}
                        isVisible={hasServerError && !hasValidationError}/>
                </div>
            </div>);
    }
}

VerifyEmailForm.propTypes = {
    email: PropTypes.string,
    serverError: PropTypes.string,
    sendVerifyEmail: PropTypes.func,
    step: PropTypes.string,
    authenticationTypeChanged: PropTypes.bool
};

const mapStateToProps = state => ({
    email: state.loginState.email,
    serverError: state.loginState.loginFailure,
    step: state.loginState.loginStep,
    authenticationTypeChanged: state.loginState.authenticationTypeChanged
});

const mapDispatchToProps = dispatch=> {
    return ({
        resendUserSetPassword: (virtualUserId) => {
            dispatch(resendUserSetPasswordEmail(virtualUserId));
        }
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailForm);
